import type {
    AcceptCommerceShareRequest,
    AcceptCommerceShareResponse,
    CommerceOperationOptions,
    CommerceSharePreview,
    CommerceShareResource,
    CommerceShareTarget,
} from "@teqtank/commerce-contracts";
import { CommerceRepository } from "../repositories/commerce-repository.js";
import { createCommerceShareResourceOperation } from "../operations/create-commerce-share-resource-operation.js";
import { resolveCommerceShareOperation } from "../operations/resolve-commerce-share-operation.js";
import { acceptCommerceShareOperation } from "../operations/accept-commerce-share-operation.js";
export class CommerceShareRepository extends CommerceRepository {
    public async create(
        target: CommerceShareTarget,
        options: CommerceOperationOptions,
    ): Promise<CommerceShareResource> {
        return (
            await this.execute(
                createCommerceShareResourceOperation,
                { target },
                options,
                "share-operation-failed",
                "Teqtank Commerce could not create the share resource.",
            )
        ).share;
    }
    public async resolve(
        shareId: string,
        options: CommerceOperationOptions,
    ): Promise<CommerceSharePreview> {
        return (
            await this.execute(
                resolveCommerceShareOperation,
                { shareId },
                options,
                "share-operation-failed",
                "Teqtank Commerce could not resolve the shared experience.",
            )
        ).preview;
    }
    public async accept(
        request: AcceptCommerceShareRequest,
        options: CommerceOperationOptions,
    ): Promise<AcceptCommerceShareResponse> {
        return this.execute(
            acceptCommerceShareOperation,
            request,
            options,
            "share-operation-failed",
            "Teqtank Commerce could not apply the shared experience to the Cart.",
        );
    }
}
